export const environment = {
  production: false,
  buildNo:202610281911,
  version: 'Dev 2.0.1',
  baseUrl: 'https://dev.csmsv2-api.mojosoft.work/',
  assetsUrl: 'https://dev.oov2.mojosoft.work/resources',
  assetsPosAdsPath: '/ads/pos',
  userId: 'epsv2',
  password: 'epsv2dev',
  appKey: "21a1e0ea3ab799781fae22c4feef5fe7"
};
